import { useState } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CustomTooltip from 'components/tooltip/CustomTooltip';
import Carousel from 'react-material-ui-carousel';
import { useContext } from 'react';
import { ClosestStationContext } from 'contexts/ClosestStationContext';
import { WIND_ROSES_BASE_PATH } from 'constants/simulation';

const WindSpeedScalar = () => {
  const { closestStation } = useContext(ClosestStationContext);
  const [open, setOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState('');

  const handleOpen = (pImage: string) => {
    setCurrentImage(pImage);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  /**
   * Converts from "Aadorf / Tänikon" to "Aadorf_Tänikon".
   */
  const convertStationName = (pStationName: string | undefined) => {
    // return pStationName?.replace(/\//g, ':');
    return pStationName?.replace(/\s*\/\s*/g, '_');
  };

  const getWindRoseUrl = (stationName: string | undefined, imageName: string) => {
    const normalizedStationName = convertStationName(stationName);

    if (!normalizedStationName) {
      return '';
    }

    return `${WIND_ROSES_BASE_PATH}/${encodeURIComponent(normalizedStationName)}/${imageName}.jpg`;
  };

  return (
    <>
      <Typography variant="subtitle1">
        <span className="grid-inline-label-with-info">
          <span>Wind roses:</span>
          <CustomTooltip
            title={
              'This wind data is derived from climate normals, long-term averages aggregating past mesured data over 10-30 years. The wind rose shows how wind speed and direction are distributed at this location. They illustrate the direction from which the wind is blowing over the year, 4 seasons, or 12 months. The length of each segment is related to the frequency (%) with which the wind blows from that particular direction and the gray bands show the differnet speed ranges (m/s).'
            }
          />
        </span>
      </Typography>

      <Typography variant="subtitle1">Data Source: Meteosuisse 1991-2020 Climate Normals.</Typography>

      <Carousel sx={{ border: '1px solid' }} autoPlay={false} navButtonsAlwaysVisible={true} indicators={false}>
        <Box className="wind-roses-image-container">
          <img
            src={getWindRoseUrl(closestStation?.station, 'yearly')}
            alt="Yearly wind rose"
            onClick={() => handleOpen('yearly')}
          />
        </Box>
        <Box className="wind-roses-image-container">
          <img
            src={getWindRoseUrl(closestStation?.station, 'seasonal')}
            alt="Seasonal wind rose"
            onClick={() => handleOpen('seasonal')}
          />
        </Box>
        <Box className="wind-roses-image-container">
          <img
            src={getWindRoseUrl(closestStation?.station, 'monthly')}
            alt="Monthly wind rose"
            onClick={() => handleOpen('monthly')}
          />
        </Box>
      </Carousel>

      <br />

      <Modal open={open} onClose={handleClose}>
        <Box
          className="wind-roses-modal-container"
          sx={{
            width: 'auto',
            height: '90vh',
            maxWidth: 'none',
            maxHeight: 'none',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 'auto',
            backgroundColor: 'white',
          }}
        >
          <div>
            <img
              src={getWindRoseUrl(closestStation?.station, currentImage)}
              alt=""
              style={{
                width: 'auto',
                height: '90vh',
                objectFit: 'contain',
              }}
            />
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default WindSpeedScalar;
